module.exports = __webpack_public_path__ + "img/cave.56da194a.jpg";